import { Jumbotron, Container } from 'react-bootstrap'
import errorImage from './../img/payment_error.svg'

const AntwerpenInfoB = () => {
  return (
    <Container>
      <Jumbotron className='text-center'>
        <img className='mb-4' src={errorImage} alt='error' />
        <p>Error: Belangrijke boodschap voor de mandatarissen met hoofdinschrijving bij Balie Antwerpen: Vanaf 01/04/2023 is het niet langer mogelijk zijn mandaten via dit platform te verzekeren, ook niet als ze toegekend werden voor 01/01/2023.</p>
        <p>Voor vragen kan u contact opnemen per mail via het adres <a href="mailto:spccb@vanbreda.be">spccb@vanbreda.be</a>.</p>
      </Jumbotron>
    </Container>
  )
}

export default AntwerpenInfoB
